// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__21HjO","content":"LoadingAlert_content__1QP_t"};